import React from 'react';
import * as styles from './styles/styles.module.scss';
import { Benefit } from './benefitsUtil';

type BenefitCardProps = {
  benefit: Benefit;
};

const BenefitCard = ({ benefit }: BenefitCardProps): JSX.Element => {
  const { title, desc, iconSrc } = benefit;
  return (
    <div className={styles.benefitCard}>
      <img src={iconSrc} className={styles.benefitIcon} />
      <div className={styles.benefitTitle}>{title}</div>
      <div className={styles.benefitDesc}>{desc}</div>
    </div>
  );
};

export { BenefitCard as default, BenefitCardProps };
